import { type ChangeEvent } from 'react'

interface Props {
  label: string
  imageCapture: (event: ChangeEvent<HTMLInputElement>, side: string) => {}
  documentSide: string
  disabled?: boolean
  className?: string
}

const OpenDeviceCamera = ({ label, className = '', imageCapture, documentSide, disabled }: Props) => {
  const handleCapture = (event: ChangeEvent<HTMLInputElement>) => {
    imageCapture(event, documentSide)
  }
  return (
    <>
      <input
        disabled={disabled}
        type="file"
        accept="image/*"
        onChange={handleCapture}
        capture="camera"
        id="camera-photo"
        hidden
      />
      <label
        id="take-document-photo"
        className={`take-picture-btn ${className} ${disabled ? 'btn-disabled' : ''}`}
        htmlFor="camera-photo"
      >
        {label}
      </label>
    </>
  )
}

export default OpenDeviceCamera
